import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { Form } from "formik";
import { CUSTOM_FIELD_MODAL_FORM_ID } from "../CustomFieldModal";
export const CustomFieldModalFormContainer = (param)=>{
    let { children, innerScroll } = param;
    return /*#__PURE__*/ _jsx(Form, {
        id: CUSTOM_FIELD_MODAL_FORM_ID,
        "data-testid": "CUSTOM_FIELD_MODAL",
        className: classNames("relative max-h-[500px] px-px py-1", innerScroll ? "overflow-y-auto" : ""),
        children: children
    });
};
